export default __webpack_public_path__ + "static/media/error.812c0bde.svg";